<template>
  <div class="p-6 pr-6 all">
    <div>
      <div class="flex items-center">
        <div class="w-1/2 flex text-left text-c34 2xl:text-c42 items-center font-c8">
          Cimetière
        </div>
        <div class="w-1/2 flex justify-end gap-4">
          <buton
            :label="showWithoutBackup ? 'Avec sauvegarde' : 'Aucune sauvegarde'"
            class="w-72"
            size="18px"
            rounded="6px"
            weight="500"
            height="50px"
            :background="showWithoutBackup ? '#28a745' : '#312879'"
            @click="toggleBackupFilter"
          />
          <multiDate
            class="w-80"
            @info="updateDateFilter"
          />
        </div>
      </div>
             
      <!-- En-têtes du tableau -->
      <div class="w-full flex text-6b text-c16 font-c7 text-left mt-6 border-gray border-b p-7 bg-white">
        <div class="w-1/4">
          Nom
        </div>
        <div class="w-1/5 ml-4">
          Catégorie
        </div>
        <div class="w-1/5 ml-4">
          Taille
        </div>
        <div class="w-1/6 ml-4">
          Dernière sauvegarde
        </div>
        <div class="w-1/6 ml-4">
          Dernière relance
        </div>
        <div class="w-1/6 ml-4">
          Relance
        </div>
      </div>
             
      <!-- Composant global-view avec filtres -->
      <div class="">
        <global-view
          :search="recherche"
          :filtrage="valueCategorie"
          :start-date="startDate"
          :end-date="endDate"
          :show-without-backup="showWithoutBackup"
          @filt="filtrage = null"
        />
      </div>
    </div>
  </div>
</template>

<script>
import search from '../../assets/icons/search.svg'
import globalView from '../../component/cdevs/cimetiere/globalData'
import multiDate from "../../component/helper/form/multipleDate.vue";
import buton from '../../component/helper/add/button.vue';

export default {
  name: "Index",
  
  components: {
    globalView, 
    multiDate,
    buton
  },
  
  data() {
    return {
      icons: {
        search
      },
      recherche: null,
      startDate: null,
      endDate: null,
      valueCategorie: null,
      filtrage: null,
      showWithoutBackup: false // false = avec sauvegarde, true = sans sauvegarde
    }
  },
  
  methods: {
    retourSearch(answer) {
      this.recherche = answer
    },
    
    goTo() {
      this.$router.push('access')
    },
    
    // Fonction pour mettre à jour les dates de filtre
    updateDateFilter(range) {
      console.log('Dates sélectionnées:', range);
      this.startDate = range.start;
      this.endDate = range.end;
    },
    
    // Fonction pour basculer entre "avec sauvegarde" et "sans sauvegarde"
    toggleBackupFilter() {
      this.showWithoutBackup = !this.showWithoutBackup;
      console.log('Filtre sauvegarde:', this.showWithoutBackup ? 'Sans sauvegarde' : 'Avec sauvegarde');
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-icon {
  fill: white;
}

.all {
  min-height: 100vh;
}
</style>